import { useI18n } from "../lib/LanguageContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { Globe } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useI18n();
  const current = languages.find(l => l.code === lang) || languages[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-full h-9 px-3 gap-1.5" data-testid="lang-switcher">
          <Globe className="w-3.5 h-3.5"/>
          <span className="text-xs font-medium uppercase">{current.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white">
        {languages.map(l => (
          <DropdownMenuItem key={l.code} onClick={()=>setLang(l.code)} className="cursor-pointer gap-2" data-testid={`lang-${l.code}`}>
            <span className="text-base">{l.flag}</span>
            <span className={l.code === lang ? "text-teal font-semibold" : ""}>{l.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
